/**
 * Filtro avançado com muitas referências — usa POST /search em vez de GET com URL gigante.
 */
import { getTopIndex } from '../../versa/record.js';

/**
 * @param {Record<string, unknown>|null|undefined} filterData
 * @param {number} [minRefs=20]
 * @returns {{ references: string[], operator: string }|null}
 */
export function buildReferenceBulkSearch(filterData, minRefs = 20)
{
	if (!filterData)
		return null;
	const references = [];
	const operators = new Set();
	const top = getTopIndex(filterData);
	for (let i = 0; i <= top; i++)
	{
		const field = filterData[`field-${i}`];
		const value = String(filterData[`value-${i}`] ?? '').trim();
		if (!field && !value)
			continue;
		if (field !== 'reference')
			return null;
		const operator = String(filterData[`operator-${i}`] || 'eq').toLowerCase();
		if (!['eq', 'co'].includes(operator) || !value)
			return null;
		references.push(value);
		operators.add(operator);
	}
	const uniqueReferences = [...new Set(references)];
	if (uniqueReferences.length < minRefs)
		return null;
	// CSV importado usa «contém» (co); referências SESSP costumam ser «empenho|número» (ex.: 1379262|2956609).
	// Não forçar eq só por ser numérico — isso zera o resultado.
	if (operators.has('co') && operators.has('eq'))
		return null;
	return {
		references: uniqueReferences,
		operator: operators.has('co') ? 'co' : 'eq',
	};
}

/**
 * @param {Record<string, unknown>|null|undefined} filterData
 * @param {string} query
 * @param {number} [minRefs=20]
 * @returns {object|null}
 */
export function referenceSearchPayloadFromQuery(filterData, query, minRefs = 20)
{
	const bulk = buildReferenceBulkSearch(filterData, minRefs);
	if (!bulk)
		return null;
	const params = new URLSearchParams(String(query || '').replace(/^\?/, ''));
	return {
		...bulk,
		group: params.get('group') === 'count' ? 'count' : undefined,
		sort: params.get('sort') || undefined,
		limit: params.get('limit') || undefined,
		offset: params.get('offset') || undefined,
	};
}
